import React, { FC } from "react";
import { IStepTemplate } from "../../../types";
import { DetailImages } from "../../../components/step4/DetailImages";
import { AccordionList } from "../../../../../../components/AccordionList";
import { programDetailsConfig } from "../../../../constants";

const Template: FC<IStepTemplate> = ({ stepName }) => (
  <>
    <AccordionList
      title="Program Details"
      fieldName={`${stepName}.details`}
      configs={programDetailsConfig}
    />
    <DetailImages name={stepName} />
  </>
);

export default Template;
